<div
    class="step-item"
    (click)="onClick(step)"
    [ngClass]="{ 'non-interactive-step': !stepInteractive, 'modal-style': initModalStyle }"
    [attr.data-certificate-details-step-type-id]="stepTypeId"
    [ngbTooltip]="stepTooltip"
>
    <div class="step-item__icon-column">
        <cm-step-icon
            [tooltipHidden]="tooltipHidden"
            [statusColor]="stepStatusColor"
            [stepType]="stepTypeId"
            class="step-item__icon"
        >
        </cm-step-icon>
        <cm-rejected-hint
            *ngIf="rejectType"
            [organizationContactData]="organizationContactData"
            [type]="rejectType"
            [id]="stepId"
            [notes]="rejectComments"
            [rejectStepData]="step?.rejectStepData"
            [onlyIcon]="step?.content?.responsibleToComplete === LOG_STEP_RESPONSIBLE_TO_COMPLETE.SUPERVISOR"
            (modalConfirm)="onRejectHintConfirm()"
            class="step-item__rejected-hint"
        ></cm-rejected-hint>
        <cm-optional-hint
            *ngIf="!rejectType && optionalType"
            [organizationContactData]="organizationContactData"
            [type]="optionalType"
            [id]="stepId"
            class="step-item__rejected-hint"
        ></cm-optional-hint>
    </div>
    <div class="step-item__data">
        <div class="data-title">
            <p class="step-item__data-title" [ngClass]="{ 'passed-date': step.isPassedDueDate }">{{ step.name }}</p>
            <cm-step-item-indicators [step]="step"></cm-step-item-indicators>
        </div>
        <div><ng-container [ngTemplateOutlet]="stepData"></ng-container></div>
    </div>
    <div class="step-item__data hidden-block"><ng-container [ngTemplateOutlet]="stepData"></ng-container></div>
</div>

<ng-template #stepData>
    <div class="step-item__data-status" [ngClass]="{ 'passed-date': step.isPassedDueDate, steps: initModalStyle }">
        <span class="step-item__data-part step-item__data-step-type-name">
            {{ STEP_TYPES_NAMES[stepTypeId] }}
            <!--            TODO: NO CONTENT <span *ngIf="stepTypeId === STEP_TYPES.LOG">({{ step.content.role }})</span>-->
        </span>
        <p *ngIf="!stepWithoutStatus.includes(stepTypeId)">
            <cm-status-label
                class="step-item__data-part step-status"
                [toBeAudited]="isStepForAudit"
                [statusId]="auditStatusId || stepStatusId"
                [statusIconTooltip]="statusTooltip"
                [organizationContactData]="organizationContactData"
                [isDetailsView]="true"
                [showEditIcon]="showResetIcon"
                [editIconTooltip]="resetStepTooltip"
                [type]="auditStatusId ? TYPES.AUDIT_STEP : TYPES.STEP"
            >
            </cm-status-label>
        </p>
        <span class="step-item__data-part due-date">
            Due: {{ stepEndDate | dateFormat }} {{ isDueDate ? (stepEndDate | daysLeft) : '' }}
        </span>
    </div>
    <p *ngIf="!educationAdvancedOptionsAllowed && unitsData" class="step-item__data-status">
        {{ educationUnitName }}:
        <span class="step-item__data-status-text">
            Incomplete ({{ unitsData.unitsIncompleted }}),
            <ng-container *ngIf="isEducationVerificationRequired"
                >Pending verification ({{ unitsData.unitsPendingVerification }}),</ng-container
            >
            Completed ({{ unitsData.unitsCompleted }})
        </span>
    </p>
    <p *ngIf="step?.content?.compliance_criteria_type_id" class="step-item__data-status">
        {{ COMPLIANCE_CRITERIA.ENTRIES === step.content?.compliance_criteria_type_id ? 'Entries' : 'Hours' }}:
        <span class="step-item__data-status-text">
            Required ({{ step.content?.number_required }}), Completed ({{ step.content?.number_completed }})
        </span>
    </p>
    <cm-display-html class="step-item__description" [content]="step.description"></cm-display-html>
    <a *ngIf="step.psi_site_link && stepInteractive" class="cm-link" [href]="step.psi_site_link">Login to PSI system</a>
    <div [ngSwitch]="stepTypeId">
        <div *ngSwitchCase="STEP_TYPES.PRACTICE_TEST">
            <span class="step-details-url">Practice Test URL: </span>
            <a [href]="step.practiceTestUrl" target="_blank" class="cm-link">{{ step.practiceTestUrl }}</a>
        </div>
        <div *ngSwitchCase="STEP_TYPES.SCHEDULING">
            <button
                *ngIf="step.schedulingUrl"
                class="btn btn-default"
                type="button"
                (click)="navigateToURL(step.schedulingUrl)"
            >
                Click here to schedule
            </button>
            <button
                *ngIf="step.reSchedulingUrl"
                class="btn btn-default"
                type="button"
                (click)="navigateToURL(step.reSchedulingUrl)"
            >
                Click here to reschedule
            </button>
            <div *ngIf="stepStatusId === STEP_TYPE_STATUSES.COMPLETED">
                <ng-container *ngTemplateOutlet="exam_location_date_time; context: { step: step }"></ng-container>
            </div>
        </div>
        <div *ngSwitchCase="STEP_TYPES.TEST_SCHEDULING_VERIFICATION">
            <ng-container *ngIf="step.isAbsentSchedulingStep">
                <button
                    *ngIf="step.schedulingUrl"
                    class="btn btn-default"
                    type="button"
                    (click)="navigateToURL(step.schedulingUrl)"
                >
                    Click here to schedule
                </button>
                <button
                    *ngIf="step.reSchedulingUrl"
                    class="btn btn-default"
                    type="button"
                    (click)="navigateToURL(step.reSchedulingUrl)"
                >
                    Click here to reschedule
                </button>
            </ng-container>
            <div *ngIf="stepStatusId === STEP_TYPE_STATUSES.COMPLETED">
                <ng-container *ngTemplateOutlet="exam_location_date_time; context: { step: step }"></ng-container>
            </div>
        </div>
        <div *ngSwitchCase="STEP_TYPES.TEST_TAKING">
            <div *ngIf="step.testTakingUrl">
                <span class="step-details-url">Test Taking URL: </span>
                <a [href]="step.testTakingUrl" target="_blank" class="cm-link">{{ step.testTakingUrl }}</a>
            </div>
            <div *ngIf="stepStatusId === STEP_TYPE_STATUSES.COMPLETED">
                <ng-container *ngTemplateOutlet="exam_location_date_time; context: { step: step }"></ng-container>
                <button
                    *ngIf="step.schedulingUrl"
                    class="btn btn-default"
                    type="button"
                    (click)="navigateToURL(step.schedulingUrl)"
                >
                    Click here to schedule
                </button>
                <button
                    *ngIf="step.reSchedulingUrl"
                    class="btn btn-default"
                    type="button"
                    (click)="navigateToURL(step.reSchedulingUrl)"
                >
                    Click here to reschedule
                </button>
            </div>
        </div>
        <div *ngSwitchCase="STEP_TYPES.TEST_TAKING_VERIFICATION">
            <div *ngIf="stepStatusId === STEP_TYPE_STATUSES.COMPLETED || step.isAbsentTestTakingStep">
                <ng-container *ngTemplateOutlet="exam_location_date_time; context: { step: step }"></ng-container>
                <div *ngIf="step.status">
                    <span class="step-details-url">Status: </span> <span>{{ step.status }}</span>
                </div>
                <ng-container *ngIf="step.isAbsentTestTakingStep">
                    <button
                        *ngIf="step.schedulingUrl"
                        class="btn btn-default"
                        type="button"
                        (click)="navigateToURL(step.schedulingUrl)"
                    >
                        Click here to schedule
                    </button>
                    <button
                        *ngIf="step.reSchedulingUrl"
                        class="btn btn-default"
                        type="button"
                        (click)="navigateToURL(step.reSchedulingUrl)"
                    >
                        Click here to reschedule
                    </button>
                </ng-container>
            </div>
        </div>
        <div *ngSwitchCase="STEP_TYPES.TEST_SCORE_VALIDATION">
            <span class="step-details-url" *ngIf="step.score || step.score === 0">Score: </span>
            <span>{{ step.score }}</span
            ><br />
            <span class="step-details-url" *ngIf="step.examStatusId">Result: </span>
            <span>{{ EXAM_STATUSES[step.examStatusId] }}</span
            ><br />
        </div>
    </div>
</ng-template>
<ng-template #exam_location_date_time let-step="step">
    <div *ngIf="step.location">
        <span class="step-details-url">Location: </span> <span>{{ step.location }}</span>
    </div>
    <ng-container *ngIf="step.examDate">
        <div>
            <span class="step-details-url">Date: </span>
            <span>{{ step.examDate | dateFormat: 'dateWithMonthName':true }}</span>
        </div>
        <div>
            <span class="step-details-url">Time: </span>
            <span>{{ (step.examDate | dateFormat: 'time':true) + ' ' + (step.testingCenterTimezoneCode || '') }}</span>
        </div>
    </ng-container>
</ng-template>
